export enum PlatformEnum {
  ANDROID = 'android',
  IPHONE = 'iphone',
  IPAD = 'ipad',
}
